/** Legacy `<!-- zw-align -->` wrapper lines (pre-`.zwdoc`; read-only). */

export type TextAlign = "left" | "center" | "right" | "justify";

/** Comment markers. Own-line HTML comments don't swallow markdown (unlike <div>). */
export const ALIGN_OPEN =
  /^<!--\s*zw-align:\s*(left|center|right|justify)\s*-->\s*$/i;
export const ALIGN_CLOSE = /^<!--\s*\/zw-align\s*-->\s*$/i;

/** Legacy div wrappers from the first alignment implementation. */
export const ALIGN_OPEN_LEGACY =
  /^<div\s+style="text-align:\s*(left|center|right|justify);?\s*">\s*$/i;
export const ALIGN_CLOSE_LEGACY = /^<\/div>\s*$/i;

export function parseAlignOpen(text: string): TextAlign | null {
  const trimmed = text.trim();
  const match = ALIGN_OPEN.exec(trimmed) ?? ALIGN_OPEN_LEGACY.exec(trimmed);
  const align = match?.[1];
  return typeof align === "string" && align.length > 0
    ? (align.toLowerCase() as TextAlign)
    : null;
}

export function isAlignClose(text: string): boolean {
  const trimmed = text.trim();
  return ALIGN_CLOSE.test(trimmed) || ALIGN_CLOSE_LEGACY.test(trimmed);
}

export function isAlignMarkerLine(text: string): boolean {
  return parseAlignOpen(text) !== null || isAlignClose(text);
}
